import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Appointment } from '@models/appointments/appointment.model';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { HttpBaseService } from './http-base.service';
import { AuthService } from './auth.sevice';
import { AuthTokenHelper } from '../helpers/auth-token-helper';
import { DatePipe } from '@angular/common';
import { BeyondEMRConstants } from '@helpers/beyondemrconstants';

@Injectable()
export class AppointmentService {
  private readonly API_URL = 'assets/data/appointment.json';
  dataChange: BehaviorSubject<Appointment[]> = new BehaviorSubject<Appointment[]>([]);
  // Temporarily stores data from dialogs
  dialogData: any;
  constructor(private httpClient: HttpClient, private httpBaseService: HttpBaseService, public datepipe: DatePipe, private authService?: AuthService, private authHelper?: AuthTokenHelper) { }

  get data(): Appointment[] {
    return this.dataChange.value;
  }

  getDialogData() {
    return this.dialogData;
  }

  /** CRUD METHODS */
  getAllHolidays(): void {
    this.httpClient.get<Appointment[]>(this.API_URL).subscribe(
      data => {
        this.dataChange.next(data);
      },
      (error: HttpErrorResponse) => {
        console.log(error.name + ' ' + error.message);
      }
    );
  }

  getAppointmentMaster(URL): Observable<any> {
    try {
      const body = {};
      return this.httpBaseService.get(URL, body);
    } catch (error) {
      console.log(error.name + ' ' + error.message);
      return new Observable<any>();
    }
  }
  getAllAppointment(URL): Observable<any> {
    try {
      const body = {};
      return this.httpBaseService.post(URL, body);
    } catch (error) {
      console.log(error.name + ' ' + error.message);
      return new Observable<any>();
    }
  }

  addAppointment(appointment: Appointment): void {
    this.dialogData = appointment;
  }

  updateAppointment(appointment: Appointment): void {
    this.dialogData = appointment;
  }

  deleteAppointment(id: number): void {
    console.log(id);
  }

  GetSlots(url: string, appointment: Appointment): Observable<any> {
    try {
      const param = { appointmentDate: (appointment.AppointmentDate ? this.datepipe.transform(appointment.AppointmentDate, BeyondEMRConstants.DateDBFormat) : ''), providerId: appointment.ProviderId };
      return this.httpBaseService.get(url, param);
    } catch (error) {
      console.log(error.name + ' ' + error.message);
      return new Observable<any>();
    }
  }

  SaveProviderDetails(url: string, appointment: Appointment): Observable<any> {
	  try {
      appointment.AppointmentDate = this.datepipe.transform(new Date(appointment.AppointmentDate ? appointment.AppointmentDate : new Date()), BeyondEMRConstants.DateDBFormat);
      if (appointment.StartTime) {
        let startTime = this.datepipe.transform(appointment.AppointmentDate, BeyondEMRConstants.DateDBFormat);
        startTime = startTime + ' ' + appointment.StartTime;
        appointment.StartTime = this.datepipe.transform(new Date(startTime), 'MM/dd/yyyy HH:mm');
      }
     
      return this.httpBaseService.post(url, appointment);
    } catch (error) {
      console.log(error.name + ' ' + error.message);
      return new Observable<any>();
    }
  }

  SaveSlotDetails(url: string, appointment: Appointment): Observable<any> {
    try {
      appointment.AppointmentDate = this.datepipe.transform(new Date(appointment.AppointmentDate ? appointment.AppointmentDate : new Date()), BeyondEMRConstants.DateDBFormat);
      if (appointment.StartTime) {
        let startTime = appointment.StartTime;
        appointment.StartTime = this.datepipe.transform(new Date(startTime), 'HH:mm');
      }

      return this.httpBaseService.post(url, appointment);
    } catch (error) {
      console.log(error.name + ' ' + error.message);
      return new Observable<any>();
    }
  }

  GetRoomDetails(url: string, appointment: Appointment): Observable<any> {
	  try {
		  const param = { roomId: appointment.RoomId, appointmentDate: appointment.AppointmentDate, startTime: appointment.StartTime, id: appointment.Id, serviceLocationId: appointment.ServiceLocationId };
      return this.httpBaseService.get(url, param);
    } catch (error) {
      console.log(error.name + ' ' + error.message);
      return new Observable<any>();
    }
  }

  UpdateStatus(url: string, id: number, statusId: number): Observable<any> {
    try {
      return this.httpBaseService.get(url, { id: id, statusId: statusId });
    } catch (error) {
      console.log(error.name + ' ' + error.message);
      return new Observable<any>();
    }
  }

    GetEquipmentDetails(url: string, appointment: Appointment): Observable <any> {
      try {
		  const param = { equipmentId: appointment.EquipmentId, appointmentDate: appointment.AppointmentDate, startTime: appointment.StartTime, id: appointment.Id, serviceLocationId: appointment.ServiceLocationId };
        return this.httpBaseService.get(url, param);
      } catch(error) {
        console.log(error.name + ' ' + error.message);
        return new Observable<any>();
      }
  }

  UpdateCaseId(url: string, id: number, insuranceCaseId: number, autharization: string): Observable<any> {
    try {
      return this.httpBaseService.get(url, { id: id, insuranceCaseId: insuranceCaseId, autharization: autharization });
    } catch (error) {
      console.log(error.name + ' ' + error.message);
      return new Observable<any>();
    }
  }

  CheckForExistingSlot(url: string, id: number, providerId: number, startTime: any, appointmentDate: any): Observable<any> {
    try {
      return this.httpBaseService.get(url, { id: id, providerId: providerId, slotStartTime: startTime, appointmentDate: appointmentDate });
    } catch (error) {
      console.log(error.name + ' ' + error.message);
      return new Observable<any>();
    }
  }

  GetPatientInsurance(url: string): Observable<any> {
    try {
      const param = {};
      return this.httpBaseService.get(url, param);
    } catch (error) {
      console.log(error.name + ' ' + error.message);
      return new Observable<any>();
    }
  }

  GetPatientAlert(url: string): Observable<any> {
    try {
      const param = {};
      return this.httpBaseService.get(url, param);
    } catch (error) {
      console.log(error.name + ' ' + error.message);
      return new Observable<any>();
    }
  }

  GetAppointmentDetails(url: string): Observable<any> {
    try {
      const param = {};
      return this.httpBaseService.get(url, param);

    } catch (error) {
      console.log(error.name + ' ' + error.message);
      return new Observable<any>();
    }
	}

	SaveAppointmentsDetails(url: string, appointment: Appointment): Observable<any> {
    try {
      appointment.AppointmentDate = this.datepipe.transform(appointment.AppointmentDate, BeyondEMRConstants.DateDBFormat);
			appointment.StartTime = this.datepipe.transform(new Date(appointment.StartTime), 'MM/dd/yyyy HH:mm');
			appointment.EndTime = this.datepipe.transform(new Date(appointment.EndTime), 'MM/dd/yyyy HH:mm');

			return this.httpBaseService.post(url, appointment);
		} catch (error) {
			console.log(error.name + ' ' + error.message);
			return new Observable<any>();
		}
  }

  ValidateTimeOffEvent(url: string, appointment: Appointment): Observable<any> {
    try {
      var data = new Appointment();
      data.ProviderId = appointment.ProviderId;
      data.AppointmentDate = this.datepipe.transform(new Date(appointment.AppointmentDate ? appointment.AppointmentDate : new Date()), BeyondEMRConstants.DateDBFormat);
      data.StartTime = this.datepipe.transform(new Date(appointment.StartTime), 'MM/dd/yyyy HH:mm');
      data.EndTime = this.datepipe.transform(new Date(appointment.EndTime), 'MM/dd/yyyy HH:mm');

      return this.httpBaseService.post(url, data);
    } catch (error) {
      console.log(error.name + ' ' + error.message);
      return new Observable<any>();
    }
  }

  CheckForProviderAvailability(url: string, providerId: number, startTime: any, endTime: any, servicelocationId: any): Observable<any> {
  try {
      return this.httpBaseService.get(url, {providerId: providerId, startTime: startTime, endTime: endTime, servicelocationId: servicelocationId });
    } catch (error) {
      console.log(error.name + ' ' + error.message);
      return new Observable<any>();
    }
  }
}

